import type { Product } from "@/types";
import { formatCOP, formatNumber } from "@/utils/format";

const STAT_META = [
  { icon: "ri-store-2-line", label: "Referencias en catálogo", bubble: "bg-primary-500/25 text-primary-100" },
  { icon: "ri-price-tag-3-line", label: "Valor catálogo (precio público)", bubble: "bg-accent-500/20 text-accent-200" },
  { icon: "ri-percent-line", label: "Margen promedio", bubble: "bg-secondary-500/25 text-secondary-200" },
  { icon: "ri-flashlight-line", label: "Puntos PV totales", bubble: "bg-primary-500/20 text-primary-100" },
];

// Resumen ejecutivo del catálogo maestro.
const CatalogStats = ({ products }: { products: Product[] }) => {
  const catalogValue = products.reduce((acc, p) => acc + p.pricePublic, 0);
  const totalPv = products.reduce((acc, p) => acc + p.pv, 0);
  const margins = products
    .filter((p) => p.pricePublic > 0)
    .map((p) => ((p.pricePublic - p.costBase) / p.pricePublic) * 100);
  const avgMargin = margins.length ? margins.reduce((a, b) => a + b, 0) / margins.length : 0;

  const values = [
    formatNumber(products.length),
    formatCOP(catalogValue),
    `${avgMargin.toFixed(1)}%`,
    formatNumber(totalPv),
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
      {STAT_META.map((meta, i) => (
        <div key={meta.label} className="glass-panel rounded-lg p-4 animate-fade-up">
          <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${meta.bubble}`}>
            <i className={`${meta.icon} text-lg`} />
          </span>
          <p className="text-[11px] text-foreground-500 mt-3">{meta.label}</p>
          <p className="text-lg md:text-xl font-heading font-extrabold text-foreground-950 mt-0.5 break-words">
            {values[i]}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CatalogStats;